import { useEffect } from "react";
import PropTypes from "prop-types";

export default function Modal({ open, onClose, title, subtitle, footer, maxWidth, children }) {
  // Close on Escape — keyboard counterpart of the backdrop click below.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    // Backdrop click-to-close; keyboard users close via the document-level
    // Escape handler above, which jsx-a11y cannot associate with this node.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <div
      className="rec-modal-scrim"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="rec-modal"
        role="dialog"
        aria-modal="true"
        style={maxWidth ? { maxWidth } : undefined}
      >
        {title && <h3>{title}</h3>}
        {subtitle && <p>{subtitle}</p>}
        {children}
        {footer && <div className="rec-modal-foot mt-[22px]">{footer}</div>}
      </div>
    </div>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  footer: PropTypes.node,
  maxWidth: PropTypes.number,
  children: PropTypes.node,
};

Modal.defaultProps = {
  open: false,
  onClose: undefined,
  title: null,
  subtitle: null,
  footer: null,
  maxWidth: undefined,
  children: null,
};
